module.exports = __webpack_public_path__ + "static/media/view-icon.602eabf2.svg";